@if (showHeader()) {
  <p class="font-header text-2xl">We're here to help.</p>

  <h2 aria-label="Have a question? Please call 352-753-6655 or fill out the form below.">
    Please call
    <a href="tel:+1-352-753-6655" class="text-primary-500 dark:text-primary-50">352-753-6655</a> or
    fill out the form below.
  </h2>
}

@if (!formSubmitted()) {
  <div
    class="mt-5 space-y-8 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 border-t border-t-gray-900/10 sm:pb-0 pt-3"
  >
    <app-form-field
      fieldId="first-name"
      label="First Name"
      [isRequired]="true"
      [formField]="contactForm.firstName"
      [isDirty]="contactForm.firstName().touched()"
      [isValid]="contactForm.firstName().valid()"
      placeholder="Enter your first name"
      invalidPlaceholder="First name is required"
    />

    <app-form-field
      fieldId="last-name"
      label="Last Name"
      [isRequired]="true"
      [formField]="contactForm.lastName"
      [isDirty]="contactForm.lastName().touched()"
      [isValid]="contactForm.lastName().valid()"
      placeholder="Enter your last name"
      invalidPlaceholder="Last name is required"
    />

    <app-form-field
      fieldId="email"
      type="email"
      label="Email"
      [isRequired]="true"
      [formField]="contactForm.email"
      [isDirty]="contactForm.email().touched()"
      [isValid]="contactForm.email().valid()"
      placeholder="Enter your email"
      invalidPlaceholder="Please enter a valid email address"
    />

    <app-form-field
      fieldId="phone"
      type="tel"
      label="Phone"
      [isRequired]="true"
      [formField]="contactForm.phone"
      [isDirty]="contactForm.phone().touched()"
      [isValid]="contactForm.phone().valid()"
      placeholder="Enter your phone"
      invalidPlaceholder="Please enter a valid phone number"
    />

    @if (showComment()) {
      <app-form-field
        fieldId="comment"
        type="textarea"
        label="Comment (optional)"
        [formField]="contactForm.comment"
        placeholder="Leave us a comment or question"
      />
    }

    <span id="submit-hint" class="sr-only">Complete all required fields to enable this button</span>
    <button
      type="button"
      [attr.aria-disabled]="!contactForm().valid() ? true : undefined"
      [attr.aria-describedby]="!contactForm().valid() ? 'submit-hint' : undefined"
      (click)="submit()"
      class="rounded-md bg-transparent px-2.5 py-1.5 text-sm font-semibold shadow-xs inset-ring inset-ring-gray-300 dark:inset-ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-900/20 w-full mt-6 cursor-pointer aria-disabled:border-gray-50 aria-disabled:bg-gray-50 aria-disabled:text-gray-300 dark:aria-disabled:text-gray-500 aria-disabled:shadow-none dark:aria-disabled:border-gray-700 dark:aria-disabled:bg-gray-700/20 aria-disabled:cursor-not-allowed"
    >
      Submit
    </button>
  </div>
}

@if (formSubmitted()) {
  <app-lotti-player [source]="successLottiSource()" class="mx-auto" />

  <div class="flex flex-col">
    <button
      type="button"
      (click)="reset()"
      class="rounded-md bg-transparent px-2.5 py-1.5 text-sm font-semibold shadow-xs inset-ring inset-ring-gray-300 dark:inset-ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-900/20 mt-6 mx-auto cursor-pointer disabled:border-gray-50 disabled:bg-gray-50 disabled:text-gray-300 dark:disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-700/20 disabled:cursor-not-allowed transition-opacity duration-500 opacity-0 {{
        successCompleted() ? 'opacity-100' : ''
      }}"
    >
      Submit Another Response
    </button>
  </div>
}
